import { evaluateRouteRedirect } from '../utils';

/**
 * Handle auth redirects if a user isn't allowed to view a page. The route should
 * contain information on its permissions and where to go if the user does not
 * have permission. This should handle the scenario where a route is configured
 * to send someone to a specific location if they are not authorized to view the
 * page.
 */
const pageRedirectMiddleware = async ( action, nextRoute, _prevRoute ) => {
    // Get the path to redirect to. If `undefined` or `null`, don't redirect anywhere
    // and let the current route request go through.
    const routeRedirect = nextRoute?.match?.redirect;
    let redirectPath = undefined;
    if ( routeRedirect ) {
        redirectPath = evaluateRouteRedirect( routeRedirect );
    }

    // Redirect if the redirect path is valid.
    if ( redirectPath ) {
        action.redirect( redirectPath );
    } else {
        action.ok();
    }
};

export default pageRedirectMiddleware;
